
import { format } from "date-fns";
import { Calendar, MapPin } from "lucide-react";
import { EventImageCarousel } from "@/components/event-details/EventImageCarousel";
import { UrgencyBadge } from "@/components/event-card/UrgencyBadge";

interface EventDetailsProps {
  title: string;
  description: string;
  date: Date;
  location: string;
  startTime: string;
  endTime: string;
  imageUrl?: string | null;
  eventImages?: Array<{
    image_id: string;
    image_url: string;
    is_primary: boolean;
    display_order: number;
  }> | null;
  deadline?: string | null;
}

export const EventDetails = ({ 
  title, 
  description, 
  date, 
  location,
  startTime,
  endTime,
  imageUrl,
  eventImages,
  deadline
}: EventDetailsProps) => {
  return (
    <>
      {(eventImages?.length > 0 || imageUrl) && (
        <div className="mb-6 -mx-4">
          <EventImageCarousel 
            images={eventImages} 
            fallbackImage={imageUrl} 
            eventTitle={title} 
          />
        </div>
      )}
      
      <div className="mb-8">
        <h2 className="text-2xl font-semibold mb-2">{title}</h2>
        {deadline && <div className="mb-2"><UrgencyBadge deadline={deadline} label="to RSVP" /></div>}
        <p className="text-gray-600">{description}</p>
      </div>

      <div className="mb-8">
        <div className="flex items-start gap-2 mb-2">
          <MapPin className="w-5 h-5 text-gray-500 mt-1" />
          <div>
            <h3 className="font-medium">Location</h3>
            <p className="text-gray-600">{location || "TBD"}</p>
          </div>
        </div>
      </div>

      <div className="mb-8">
        <div className="flex items-start gap-2 mb-2">
          <Calendar className="w-5 h-5 text-gray-500 mt-1" />
          <div>
            <h3 className="font-medium">Date & Time</h3>
            <div className="bg-gray-50 rounded-lg p-4 mt-2">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-gray-500">From</p>
                  <p className="font-medium">
                    {format(date, "MMM d, yyyy")}
                  </p>
                  <p className="text-gray-600">{startTime}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">To</p>
                  <p className="font-medium">
                    {format(date, "MMM d, yyyy")}
                  </p>
                  <p className="text-gray-600">{endTime}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
